import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierPlusOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path d="M7.947 7.95v2.55h-1.4V7.95h-2.55v-1.4h2.55V4h1.4v2.55h2.55v1.4z" fill="currentColor" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M.497 7.247c0-3.375 1.687-6.75 6.75-6.75s6.75 3.375 6.75 6.75c0 1.6-.38 3.2-1.319 4.441L15.5 14.51l-.99.99-2.815-2.816c-1.046.81-2.496 1.313-4.448 1.313-5.063 0-6.75-3.375-6.75-6.75m1.4 0c0-1.48.372-2.81 1.152-3.745.742-.89 2.003-1.605 4.198-1.605 2.194 0 3.456.715 4.198 1.605.779.936 1.152 2.265 1.152 3.745s-.373 2.809-1.152 3.744c-.742.89-2.004 1.606-4.198 1.606S3.79 11.88 3.049 10.99c-.78-.935-1.152-2.265-1.152-3.744"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
MagnifierPlusOutlinedSize16Glyph.displayName = 'MagnifierPlusOutlinedSize16Glyph';
